module.exports = __webpack_public_path__ + "img/mapVisual.72a1c98e.png";